import React from 'react'
import { Input, Tooltip } from 'antd'
import {
  CopyOutlined,
  EyeInvisibleOutlined,
  EyeOutlined,
  ThunderboltOutlined,
} from '@ant-design/icons'
import { usePasswordGenerator } from '~/Hooks/usePasswordGenerator'
import { usePasswordVisibility } from '~/Hooks/usePasswordVisibility'

export interface PasswordInputProps {
  value?: string
  onChange?: (value: string) => void
  placeholder?: string
  disabled?: boolean
  showGenerator?: boolean
  showCopy?: boolean
  showVisibilityToggle?: boolean
  onGenerate?: (password: string) => void
  generatorOptions?: {
    length?: number
    includeUpper?: boolean
    includeLower?: boolean
    includeDigits?: boolean
    includeSpecial?: boolean
  }
}

export const PasswordInput: React.FC<PasswordInputProps> = ({
  value,
  onChange,
  placeholder = 'Nhập mật khẩu',
  disabled = false,
  showGenerator = true,
  showCopy = true,
  showVisibilityToggle = true,
  onGenerate,
  generatorOptions,
}) => {
  const { generatePassword, copyToClipboard } =
    usePasswordGenerator(generatorOptions)
  const { visible, toggle } = usePasswordVisibility()

  const handleGenerate = () => {
    const newPassword = generatePassword()
    onChange?.(newPassword)
    onGenerate?.(newPassword)
  }

  const handleCopy = () => {
    if (value) {
      copyToClipboard(value)
    }
  }

  const suffixIcons = (
    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
      {showVisibilityToggle && (
        <Tooltip title={visible ? 'Ẩn mật khẩu' : 'Hiển thị mật khẩu'}>
          {visible ? (
            <EyeInvisibleOutlined
              style={{ cursor: 'pointer' }}
              onClick={toggle}
            />
          ) : (
            <EyeOutlined style={{ cursor: 'pointer' }} onClick={toggle} />
          )}
        </Tooltip>
      )}

      {showGenerator && (
        <Tooltip title="Tạo mật khẩu tự động">
          <ThunderboltOutlined
            style={{ cursor: 'pointer' }}
            onClick={handleGenerate}
          />
        </Tooltip>
      )}

      {showCopy && (
        <Tooltip title="Sao chép mật khẩu">
          <CopyOutlined style={{ cursor: 'pointer' }} onClick={handleCopy} />
        </Tooltip>
      )}
    </div>
  )

  return (
    <Input
      type={visible ? 'text' : 'password'}
      value={value}
      onChange={(e) => onChange?.(e.target.value)}
      placeholder={placeholder}
      disabled={disabled}
      suffix={suffixIcons}
    />
  )
}
